import Constants from 'expo-constants'

import { Theme } from '../design-system/theme'

// Any variable here needs to appear on `eas.json` and set on
// native_apps_build.yaml for the build on EAS servers to work.

interface Config {
  ENVIRONMENT: 'local' | 'dev' | 'dev-vibe' | 'staging' | 'uat' | 'uat-vibe' | 'prod' | 'prod-vibe' | 'pen'
  /** Version is rc_vX.X.X when environment is staging, vX.X.X when is uat or prod, and dev-commitSHA when is dev. */
  VERSION: string
  APP_URL: string
  API_URL: string
  STRAPI_API_URL: string
  CLIENT_ID: string
  MERCADO_PAGO_API_URL: string
  MERCADO_PAGO_API_PUBLIC_KEY: string
  MEDIKIT_PRESCRIPTION_FILE_URL: string
  MEDIKIT_PRESCRIPTION_CHECKOUT_URL: string
  ADYEN_CLIENT_KEY: string
  I18N_DEBUG: boolean
  JWT_REFRESH_BEFORE_EXPIRATION_SECONDS: number
  OPENTOK_API_KEY: string
  OPENTOK_LOG_ENABLED: boolean
  REFRESH_INTERVAL_MS: number
  FALLBACK_LANGUAGE: string
  ZENDESK_KEY: string
  ZENDESK_SCRIPT_URL: string
  SENTRY_DSN: string
  DESIGN_SYSTEM_THEME: Theme
  VIACEP_URL: string
  NODE_CONFIG_ENV: string
  PAYMENT_PROVIDER_ACCOUNT_ID: string
  MIXPANEL_TOKEN: string
  INITIAL_PRODUCT_ID: string
}

export const {
  ENVIRONMENT,
  VERSION,
  APP_URL,
  API_URL,
  STRAPI_API_URL,
  CLIENT_ID,
  MERCADO_PAGO_API_URL,
  MERCADO_PAGO_API_PUBLIC_KEY,
  MEDIKIT_PRESCRIPTION_FILE_URL,
  MEDIKIT_PRESCRIPTION_CHECKOUT_URL,
  ADYEN_CLIENT_KEY,
  I18N_DEBUG,
  JWT_REFRESH_BEFORE_EXPIRATION_SECONDS,
  OPENTOK_API_KEY,
  OPENTOK_LOG_ENABLED,
  FALLBACK_LANGUAGE,
  ZENDESK_KEY,
  ZENDESK_SCRIPT_URL,
  SENTRY_DSN,
  DESIGN_SYSTEM_THEME,
  VIACEP_URL,
  NODE_CONFIG_ENV,
  PAYMENT_PROVIDER_ACCOUNT_ID,
  MIXPANEL_TOKEN,
  INITIAL_PRODUCT_ID,
} = (Constants.manifest?.extra as Config) ?? {}

export const REFRESH_INTERVAL_MS = 5000 // 5 seconds

export const ALERT_DURATION_MS = 10000 // 10 seconds
